import apiAthlete from '@/api/athlete'

const state = {
  error: null,
  isSubmitting: false
}

export const mutationTypes = {
  verifiedAthleteStart: '[verified athlete] verified athlete start',
  verifiedAthleteSuccess: '[verified athlete] verified athlete success',
  verifiedAthleteFailure: '[verified athlete] verified athlete failure'
}

export const actionTypes = {
  verifiedAthlete: '[verified athlete] verified athlete'
}

const mutations = {
  [mutationTypes.verifiedAthleteStart](state) {
    state.isSubmitting = true
  },

  [mutationTypes.verifiedAthleteSuccess](state) {
    state.isSubmitting = false
  },

  [mutationTypes.verifiedAthleteFailure](state, payload) {
    state.error = payload
    state.isSubmitting = false
  }
}

const actions = {
  [actionTypes.verifiedAthlete](context, data) {
    context.commit(mutationTypes.verifiedAthleteStart)
    return new Promise(resolve => {
      apiAthlete
        .verifiedAthlete(data)
        .then(response => {
          context.commit(mutationTypes.verifiedAthleteSuccess)
          resolve(response.data)
        })
        .catch(resolve => {
          context.commit(
            mutationTypes.verifiedAthleteFailure,
            resolve.response.data.errors
          )
        })
    })
  }
}

export default {
  state,
  mutations,
  actions
}
